var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3L15.2619 8.73503C15.4707 9.26443 15.575 9.52913 15.7349 9.75233C15.8766 9.95018 16.0498 10.1234 16.2477 10.2651C16.4709 10.4249 16.7356 10.5293 17.265 10.7381L23 13L17.265 15.2619C16.7356 15.4707 16.4709 15.575 16.2477 15.7349C16.0498 15.8766 15.8766 16.0498 15.7349 16.2477C15.575 16.4709 15.4707 16.7356 15.2619 17.265L13 23L10.7381 17.265C10.5293 16.7356 10.4249 16.4709 10.2651 16.2477C10.1234 16.0498 9.95018 15.8766 9.75233 15.7349C9.52913 15.575 9.26443 15.4707 8.73503 15.2619L3 13L8.73503 10.7381C9.26443 10.5293 9.52913 10.4249 9.75233 10.2651C9.95018 10.1234 10.1234 9.95018 10.2651 9.75233C10.4249 9.52913 10.5293 9.26443 10.7381 8.73503L13 3Z",
    stroke: "#EE8113",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFidIcon);
export default __webpack_public_path__ + "static/media/StarFIDIcon.73097d1203fa6f6ba3447975a18a9e4e.svg";
export { ForwardRef as ReactComponent };